export class PermitControlRoleViewModel{
    PermitTypeIds: number[]
    LoginId: string
}

export class SuspendPermitTypeViewModel{
    permitTypeIdsWithSuspendPermission: number[]
    canSuspend: boolean
}